export default "__VITE_ASSET__5c2a77cc__"